import { render, staticRenderFns } from "./politicalOutlook-select.vue?vue&type=template&id=da0203e0&scoped=true&"
import script from "./politicalOutlook-select.vue?vue&type=script&lang=js&"
export * from "./politicalOutlook-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0203e0",
  null
  
)

export default component.exports